module.exports = __webpack_public_path__ + "assets/icon_smart_report.59dfbd35.svg";